<template>
  <div class="floor-video-components">
    <div class="floor-video clearfix">
      <div class="video-item" v-for="(video, index) in videoList" :key="index">
        <floor-video-item :video="video" :blueBG="blueBG"/>
      </div>
    </div>
  </div>
</template>

<script>
import FloorVideoItem from '@/components/cloud/FloorVideoItem'

export default {
  name: 'FloorVideo',
  components: { FloorVideoItem },
  props: {
    floor: {
      type: Array,
      default () {
        return []
      },
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    // 蓝色底返回green
    blueBG () {
      if (this.index % 2 !== 0) {
        return (this.index + 1) % 4 === 0 ? 'blue' : 'green'
      } else {
        return (this.index + 2) % 4 === 0 ? 'green' : 'blue'
      }
    },
    videoList () {
      return this.floor.filter((item, index) => index < 10)
    },
  },
}
</script>

<style lang="scss">
.floor-video-components {
  margin-top: 26px;
  width: 100%;

  .floor-video {
    height: 388px;
  }

  .video-item {
    float: left;
    margin-right: 20px;
    width: 224px;

    &:nth-child(5n) {
      margin-right: 0;
    }

    &:nth-child(n+6) {
      margin-top: 30px;
    }
  }
}
</style>
